var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{attrs:{"color":"blue darken-2","inset":"","label":`Show product Synonym`},on:{"change":function($event){return _vm.setCode()}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }